import { IQuantity } from 'Data/ViewModels/Core/IQuantity';
import { IApiDataModel } from 'Data/ViewModels/IApiDataModel';
import { Guid } from 'Lib/Guid';

export type LoadIncrementReading = IApiDataModel & {
  ElapsedTime?: IQuantity;
  GaugeReading1?: number;
  GaugeReading2?: number;
  GaugeReading3?: number;
  AverageSettlement?: IQuantity;
  AverageReading?: IQuantity;
};

export interface LoadIncrement {
  LoadIncrementId: Guid;
  IncrementIndex: number;
  DesiredLoad?: IQuantity;
  DesiredPressure?: IQuantity;
  Readings?: any[];
  index?: number;
}

export interface Cycle {
  CalculateEquivalentCBR: boolean;
}

export type IncrementRecordRowDefinition = {
  ElapsedTime?: IQuantity;
  GaugeReading1?: number;
  GaugeReading2?: number;
  GaugeReading3?: number;
  AverageSettlement?: IQuantity;
  AverageReading?: IQuantity;
  index?: number;
};

export type PlateItem = {
  Id: Guid;
  Mass?: IQuantity;
  Diameter?: IQuantity;
};

export type DisplacementGaugeItem = {
  Id: Guid;
  Factor?: IQuantity;
};

export type CylinderJackItem = {
  Id: Guid;
  Mass?: IQuantity;
};

export type LoadCellItem = {
  Id: Guid;
  LoadCellFactor?: IQuantity;
};

/*
 * Indicates whether gauge readings increase or decrease as settlment increases.
 * Spectra.QEST.Contracts.Models.Soil.Tests.PlateLoading.DisplacementGaugeOrientation
 */
export enum DisplacementGaugeOrientation {
  /**
   * Displacement readings decrease as settlement increases
   */
  ReadingsDecreaseAsSettlementIncreases = 'ReadingsDecreaseAsSettlementIncreases',
  /**
   *  Displacement readings increase as settlement increases
   */
  ReadingsIncreaseAsSettlementIncreases = 'ReadingsIncreaseAsSettlementIncreases',
}
